import { first } from "rxjs/operators";
import {
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Component, Input, OnInit } from "@angular/core";
import { AlertService } from "@app/_services";
import {
  LazyLoadEvent,
  MessageService,
  ConfirmationService,
} from "primeng/api";
import { MktgLetter } from "../mktg-letter";
import { MktgLetterService } from "../mktg-letter.service";
import { MktgLetterComponent } from "../mktg-letter/mktg-letter.component";

@Component({
    selector: "app-mktg-letter-list",
    templateUrl: "./mktg-letter-list.component.html",
    styleUrls: ["./mktg-letter-list.component.css"],
    providers: [
        MessageService,
        ConfirmationService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ],
    // make column heading sticky
    styles: [
        `
      :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
      }

      @media screen and (max-width: 64em) {
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
          top: 99px;
        }
      }
    `,
    ],
    standalone: false
})
export class MktgLetterListComponent implements OnInit {
  constructor(
    private mktgLetterService: MktgLetterService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dialog: MatDialog
  ) {
    this.statuses = mktgLetterService.statuses;
  }

  // data
  @Input() showFilter = true;
  @Input() showPagination = true;
  @Input() outlineNewButton = true;
  mktgLetters: any;
  mktgLetter: MktgLetter;

  // paging
  first = 0;
  rows = 50;

  // list
  datasource: any;

  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];

  // forms
  formLoading = false;

  statuses: any;

  columns: any[] = [
    { field: "mktgLetterId", header: "Msg TemplateId", width: "auto" },
    { field: "ownerFirstName", header: "Owner FirstName", width: "auto" },
    { field: "ownerLastName", header: "Owner LastName", width: "auto" },
    { field: "adrDevelopmentName", header: "Adr Development", width: "auto" },
    { field: "targetProformaValue", header: "Target Proforma Value", width: "auto" },
    { field: "managementFee", header: "Management Fee", width: "auto" }
  ];

  ngOnInit(): void {
    try {
      // default sort of list
      this.multiSortMeta = [];
      this.multiSortMeta.push({ field: "createDate", order: 0 });
    } catch (error) {
      console.log("Error: " + error);
    }
  }

  /*********
   * Delete Button
   *
   */
  onRowDelete(event: any) {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " + event.mktgLetterId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete(event);
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  /*********
   * Lazy Load All Data
   *
   */
  loadLazy(event: LazyLoadEvent) {
    try {
      this.loading = true;
      this.lazyLoadEvent = event;

      console.log(
        " event.first:" +
          event.first +
          "  |  event.rows:" +
          event.rows +
          "  |  event.sortField:" +
          event.sortField +
          "  |  event.sortOrder:" +
          event.sortOrder +
          "  |  event.multiSortMeta:" +
          JSON.stringify(event.multiSortMeta) +
          "  |  event.globalFilter:" +
          event.globalFilter +
          "  |  event.filters:" +
          JSON.stringify(event.filters)
      );

      /*
       *
       * Default Sort
       */
      // https://stackoverflow.com/questions/679915/how-do-i-mktgLetter-for-an-empty-javascript-object
      // if we are NOT filtering and we are NOT sorting, apply a default sort
      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: "createDate", order: -1 });
      }

      const pageNumber = Math.round(event.first / event.rows);
      this.mktgLetterService
        .findByFilter(
          pageNumber,
          event.rows,
          event.sortField,
          event.sortOrder,
          event.multiSortMeta,
          event.globalFilter,
          event.filters
        )
        .pipe(first())
        .subscribe(
          (res: any) => {
            this.datasource = res.data.reviews;
            this.recordTotal = res.page.recordTotal;
            this.mktgLetters = res.data.mktgLetters;
            console.log(JSON.stringify(res.page));
          },
          (err: any) => {
            console.log("reviews list error!: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
            this.loading = false;
          }
        );

      if (this.datasource) {
        this.mktgLetters = this.datasource.slice(
          event.first,
          event.first + event.rows
        );
      }
    } catch (error) {
      console.log("loadLazy(" + event + ")" + error);
    }
  }

  getStatus() {
    return;
  }

  /*********
   * onRowSelect()
   * Used to handle row click (to edit, link, etc)
   */
  onRowSelect(event: any) {
    console.log("onRowSelect: " + JSON.stringify(event));
    this.onOpenFormEdit(event.data);
  }

  // handled in rate-bucket-form
  formAdd() {}

  /*********
   * formUpdate()
   * Used for row editing
   */
  formUpdate(mktgLetter: MktgLetter) {
    try {
      this.formLoading = true;
      this.mktgLetterService.update(mktgLetter).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Update SUCCESS: " + JSON.stringify(res));
          this.mktgLetters.map((mktgLetter, i) => {
            if (
              mktgLetter.mktgLetterId === res.data.mktgLetter.mktgLetterId
            ) {
              this.mktgLetters[i] = res.data.mktgLetter;
            }
          });
          // this.alertService.success(res, true);
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Update FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: JSON.stringify(err),
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * formDelete()
   * Used for row editing
   */
  formDelete(mktgLetter: any) {
    try {
      // stop here if form is invalid
      console.log("Delete Submitted: " + JSON.stringify(mktgLetter));

      this.formLoading = true;
      this.mktgLetterService.delete(mktgLetter.mktgLetterId).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Delete SUCCESS: " + JSON.stringify(res));
          this.mktgLetters.splice(this.mktgLetters.indexOf(mktgLetter), 1);
          this.recordTotal = this.mktgLetters.length;
          this.messageService.add({
            severity: "success",
            summary: "Successful",
            detail: "MktgLetter " + mktgLetter.mktgLetterId + " Deleted",
            life: 3000,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Delete  FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: "Delete Failed",
            detail:
              "MktgLetter " +
              mktgLetter.mktgLetterId +
              " could not be deleted.  Be sure there are no assigned properties to this bucket.",
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * Add New Button
   *
   */
  onOpenFormAdd() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: "Add Marketing Letter",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(MktgLetterComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.addMktgLetterCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /*********
   * Edit Button
   *
   */
  onOpenFormEdit(mktgLetter: MktgLetter) {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      mktgLetter: mktgLetter,
      title: "Edit MktgLetter",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(MktgLetterComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.updateMktgLetterCB(data);

      // close the dialogBox
      dialogRef.close();
    });

    dialogRef.componentInstance.doDelete.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.deleteMktgLetterCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /**
   *
   * Dialog from Form Callbacks
   * To edit the list show add/edit/delete in real time from the popup form
   *
   */
  addMktgLetterCB(mktgLetter: MktgLetter) {
    console.log("Adding MktgLetter: " + JSON.stringify(mktgLetter));
    // if we don't have a mktgLetters array yet...
    if (!this.mktgLetters) {
      this.mktgLetters = [];
    }
    // unshift adds to the front of the array (), push adds to the back
    this.mktgLetters.unshift(mktgLetter);

    // no idea what this is but it is required to update the array
    this.mktgLetters = [...this.mktgLetters];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "MktgLetter " + mktgLetter.mktgLetterId + " Added",
      life: 3000,
    });
  }

  updateMktgLetterCB(mktgLetter: MktgLetter) {
    console.log("Updating MktgLetter: " + JSON.stringify(mktgLetter));
    let itemIndex = this.mktgLetters.findIndex(
      (item: any) => item.mktgLetterId === mktgLetter.mktgLetterId
    );
    this.mktgLetters[itemIndex] = mktgLetter;

    // no idea what this is but it is required to update the array
    this.mktgLetters = [...this.mktgLetters];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "MktgLetter " + mktgLetter.mktgLetterId + " Updated",
      life: 3000,
    });
  }

  deleteMktgLetterCB(mktgLetter: MktgLetter) {
    console.log("Removing MktgLetter: " + mktgLetter);
    this.mktgLetters.splice(this.mktgLetters.indexOf(mktgLetter), 1);
    this.recordTotal = this.mktgLetters.length;

    // no idea what this is but it is required to update the array
    this.mktgLetters = [...this.mktgLetters];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "MktgLetter " + mktgLetter.mktgLetterId + " Deleted",
      life: 3000,
    });
  }

  /**********
   *
   * PAGINATOR FUNCTIONS
   */
  next() {
    this.first = this.first + this.rows;
  }
  prev() {
    this.first = this.first - this.rows;
  }
  reset() {
    this.first = 0;
  }
  isLastPage(): boolean {
    return this.mktgLetters
      ? this.first === this.mktgLetters.length - this.rows
      : true;
  }
  isFirstPage(): boolean {
    return this.mktgLetters ? this.first === 0 : true;
  }

  get Statuses() {
    return this.statuses;
  }

  getStatusName(mktgLetter: any) {
    if (mktgLetter?.status) {
      const status = this.statuses.find(
        (e: any) => e.value == mktgLetter.status
      );
      return status.name;
    } else {
      return "";
    }
  }

  reloadPage() {
    window.location.reload();
  }

  showPaginator() {
    return true;
  }
}
